function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5,
  stroke: "#A3A3A3",
  strokeWidth: 2.522,
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M8.105 2c1.091 9.337-1.018 13.228 0 19.762M1.465 24.06l6.32 7.083 7.093-6.765"
}));

var SvgArrowDown = function SvgArrowDown(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 33,
    viewBox: "0 0 17 33",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAxNyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41Ij4KPHBhdGggZD0iTTguMTA0NjYgMS45OTk1MUM5LjE5NjM3IDExLjMzNzIgNy4wODY2NCAxNS4yMjc5IDguMTA0NjIgMjEuNzYxNiIgc3Ryb2tlPSIjQTNBM0EzIiBzdHJva2Utd2lkdGg9IjIuNTIyMjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS40NjQ4NCAyNC4wNTkxTDcuNzg1MTUgMzEuMTQzM0wxNC44NzggMjQuMzc4NCIgc3Ryb2tlPSIjQTNBM0EzIiBzdHJva2Utd2lkdGg9IjIuNTIyMjkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgArrowDown as ReactComponent };